import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { PromptsTable } from '@/server/db/schema'
import { RandomFavoritesOutput } from '@/trpc/types'

export type HomeStore = {
  promptDate: Date
  favoriteDate: Date
  favorites?: RandomFavoritesOutput
  prompt?: PromptsTable
  setFavorites: (favorites: RandomFavoritesOutput) => void
  setPrompt: (prompt: PromptsTable) => void
}

const useHomeStore = create<HomeStore>()(
  persist(
    (set) => ({
      promptDate: new Date(),
      favoriteDate: new Date(),
      favorites: [],
      prompt: undefined,
      setFavorites: (favorites) => set({ favorites, favoriteDate: new Date() }),
      setPrompt: (prompt) => set({ prompt, promptDate: new Date() }),
    }),
    {
      name: 'home-store',
    },
  ),
)

export default useHomeStore
